export default function CalculsStatistiquesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('calculs.statistiques');
}

CalculsStatistiquesConfiguration.$inject = ['$translatePartialLoaderProvider'];
